// extracted by mini-css-extract-plugin
export default {"main":"Bio_main__Sndhz","bioText":"Bio_bioText__JErtw"};